import { render, staticRenderFns } from "./NumberControl.vue?vue&type=template&id=5b16a82e&scoped=true"
import script from "./NumberControl.vue?vue&type=script&lang=js"
export * from "./NumberControl.vue?vue&type=script&lang=js"
import style0 from "./NumberControl.vue?vue&type=style&index=0&id=5b16a82e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16a82e",
  null
  
)

export default component.exports